module.exports = __webpack_public_path__ + "static/media/index_34.3b7b4d0a.jpg";